import React from "react";

export default function Header() {
  return (
    <h1 className="pt-1 pb-1">
      Weather in your <span>🏡</span>
    </h1>
  );
}
